import { render, staticRenderFns } from "./CollectionBase.vue?vue&type=template&id=11f98899&scoped=true&"
import script from "./CollectionBase.vue?vue&type=script&lang=js&"
export * from "./CollectionBase.vue?vue&type=script&lang=js&"
import style0 from "./CollectionBase.vue?vue&type=style&index=0&id=11f98899&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f98899",
  null
  
)

export default component.exports